import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { setLanguage } from 'redux-i18n';
import values from 'lodash/values';

import constants from '../../../../common/constants';
import layoutConstants from '../constants/layout-constants';
import DefaultSelect from '../../../shared/default-select/components/default-select';

import '../styles/languages-picker.css';

class LanguagesPicker extends Component {
  componentDidMount() {
    const { change } = this.props;

    const lang = localStorage.getItem('lang') || 'en';
    change('languages_dropdown', lang);
  }

  handleLanguageChange(event) {
    const { setLanguage } = this.props;
    const lang = event.target.value;

    localStorage.setItem(constants.language_key_word, lang);
    setLanguage(lang);
  }

  render() {
    const { t } = this.context;
    const { uiBlocked } = this.props;

    return (
      <div className="languages-picker-container col-md-3 col-xs-12 pull-right">
        <p className="languages-picker-container__title">{t('COMMON.LANGUAGE')}</p>
        <div className="languages-picker-container__wrapper">
          <form noValidate>
            <Field
              name={'languages_dropdown'}
              id={'languages-dropdown'}
              options={values(constants.languages).filter(a => !a.hidden)}
              optionLabel={'text'}
              optionValue={'value'}
              component={DefaultSelect}
              disabled={uiBlocked}
              onChange={e => this.handleLanguageChange(e)}
            />
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  uiBlocked: state.layoutReducer.uiBlocked,
});

const mapDispatchToProps = dispatch => ({
  setLanguage: lang => {
    dispatch(setLanguage(lang));
  },
});

LanguagesPicker.contextTypes = {
  t: PropTypes.func.isRequired,
};

LanguagesPicker = reduxForm({
  form: layoutConstants.language_form,
})(LanguagesPicker);

export default connect(mapStateToProps, mapDispatchToProps)(LanguagesPicker);



// WEBPACK FOOTER //
// ./src/app/main/layout/components/languages-picker.js